import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { AntimalwareOnDemandScanTaskFrontendFields } from '../GzAntimalwareOnDemandScanTasksGridDataProvider';
import { getAntimalwareOnDemandScanTaskScanType } from '../../../../../../utils/uiSettings/antimalware/antimalware.values';

// sort by column type
export function sortByColumn(
  item1: AntimalwareOnDemandScanTaskFrontendFields,
  item2: AntimalwareOnDemandScanTaskFrontendFields,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.NAME:
      return compareStrings(item1.taskName, item2.taskName, direction);
    case ColumnKeys.SCAN_TYPE:
      return compareStrings(
        getAntimalwareOnDemandScanTaskScanType(item1.scanType),
        getAntimalwareOnDemandScanTaskScanType(item2.scanType),
        direction
      );
  }

  return 0;
}
